var installedModules = {};
var moduleToHandlerMapping = {
	8863: {
		getter: () => (() => (__webpack_require__(3823))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@paldesk/module-federation/utils",
	},
	63: {
		getter: () => (Promise.all([__webpack_require__.e(5361), __webpack_require__.e(3393)]).then(() => (() => (__webpack_require__(3393))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	9622: {
		getter: () => (Promise.all([__webpack_require__.e(63), __webpack_require__.e(3475), __webpack_require__.e(3288), __webpack_require__.e(7542), __webpack_require__.e(3705), __webpack_require__.e(2076), __webpack_require__.e(5699)]).then(() => (() => (__webpack_require__(5699))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	3475: {
		getter: () => (Promise.all([__webpack_require__.e(5361), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(3620))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	6540: {
		getter: () => (Promise.all([__webpack_require__.e(63), __webpack_require__.e(3475), __webpack_require__.e(8015)]).then(() => (() => (__webpack_require__(8015))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	6592: {
		getter: () => (Promise.all([__webpack_require__.e(63), __webpack_require__.e(7610)]).then(() => (() => (__webpack_require__(7610))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	787: {
		getter: () => (Promise.all([__webpack_require__.e(3475), __webpack_require__.e(8503)]).then(() => (() => (__webpack_require__(8503))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngx-translate/core",
	},
	714: {
		getter: () => (Promise.all([__webpack_require__.e(6658), __webpack_require__.e(1383)]).then(() => (() => (__webpack_require__(1383))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/store",
	},
	2139: {
		getter: () => (__webpack_require__.e(347).then(() => (() => (__webpack_require__(347))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/effects",
	},
	6009: {
		getter: () => (Promise.all([__webpack_require__.e(6540), __webpack_require__.e(2190), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(436))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	6628: {
		getter: () => (__webpack_require__.e(6039).then(() => (() => (__webpack_require__(6039))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	1737: {
		getter: () => (Promise.all([__webpack_require__.e(3475), __webpack_require__.e(6540), __webpack_require__.e(6592), __webpack_require__.e(787), __webpack_require__.e(714), __webpack_require__.e(2139), __webpack_require__.e(6009), __webpack_require__.e(6568), __webpack_require__.e(7776), __webpack_require__.e(230), __webpack_require__.e(3482), __webpack_require__.e(9872)]).then(() => (() => (__webpack_require__(9872))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@features/auth",
	},
	6658: {
		getter: () => (Promise.all([__webpack_require__.e(3475), __webpack_require__.e(3288), __webpack_require__.e(7542), __webpack_require__.e(3705), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(9074))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	3142: {
		getter: () => (Promise.all([__webpack_require__.e(3288), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(1803))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/signals",
	},
	3696: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(3500))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@paldesk/cookie-consent",
	},
	5262: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(4909))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/signals/entities",
	},
	7288: {
		getter: () => (Promise.all([__webpack_require__.e(1668), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(3234))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@paldesk/module-federation/header",
	},
	8014: {
		getter: () => (Promise.all([__webpack_require__.e(2190), __webpack_require__.e(9122)]).then(() => (() => (__webpack_require__(9122))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser/animations",
	},
	9382: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(8275))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/signals/rxjs-interop",
	},
	9411: {
		getter: () => (Promise.all([__webpack_require__.e(7776), __webpack_require__.e(230), __webpack_require__.e(2054)]).then(() => (() => (__webpack_require__(2054))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@shared-lib/paldesk-application",
	},
	3288: {
		getter: () => (Promise.all([__webpack_require__.e(7542), __webpack_require__.e(2076), __webpack_require__.e(5689)]).then(() => (() => (__webpack_require__(5689))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	2050: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(2867))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/di",
	},
	1799: {
		getter: () => (__webpack_require__.e(3505).then(() => (() => (__webpack_require__(3505))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "angular-oauth2-oidc",
	},
	1668: {
		getter: () => (Promise.all([__webpack_require__.e(6540), __webpack_require__.e(787), __webpack_require__.e(3142), __webpack_require__.e(9103)]).then(() => (() => (__webpack_require__(9103))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@paldesk/module-federation/shared",
	},
	3641: {
		getter: () => (Promise.all([__webpack_require__.e(3561), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(8596))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@utils/interceptors",
	},
	3561: {
		getter: () => (__webpack_require__.e(5153).then(() => (() => (__webpack_require__(5153))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@features/root-store",
	}
};
var initialConsumes = [8863];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"63": [
		63
	],
	"217": [
		5262,
		7288,
		8014,
		9382,
		9411
	],
	"714": [
		714
	],
	"787": [
		787
	],
	"1668": [
		1668
	],
	"1737": [
		1737
	],
	"2054": [
		3641
	],
	"2139": [
		2139
	],
	"3142": [
		3142
	],
	"3288": [
		3288
	],
	"3475": [
		3475
	],
	"3561": [
		3561
	],
	"3705": [
		2050
	],
	"6009": [
		6009
	],
	"6540": [
		6540
	],
	"6568": [
		6628
	],
	"6592": [
		6592
	],
	"6658": [
		6658
	],
	"7776": [
		1799
	],
	"8792": [
		8863
	],
	"9103": [
		8863
	],
	"9550": [
		3696
	],
	"9622": [
		9622
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}